import React from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from '@sentry/react';

import ErrorMessage from '../error-message/ErrorMessage';
import { isChunkLoadError } from 'src/utils/chunkErrorHandler';

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: ErrorBoundaryProps['fallback'];
}

export default function SentryErrorBoundary({
  children,
  fallback = <ErrorMessage />,
}: SentryErrorBoundaryProps) {
  return (
    <ErrorBoundary
      beforeCapture={(scope, error) => {
        // let chunk errors propagate to ChunkErrorBoundary instead
        if (isChunkLoadError(error)) {
          throw error;
        }
      }}
      fallback={fallback}
    >
      {children}
    </ErrorBoundary>
  );
}
